<template>
  <div v-if="haveBookingRequest">
    <div class="dashboard-page-title">
      <div class="container-fluid">
        <h1>Duplicate Request</h1>
      </div>
    </div>

    <booking-duplicate-form
      :booking="booking"
      :set-booking-action="setBookingRequest"
      :remove-shortlisted-talent="removeBookingRequestShortlistedTalent"
      :set-booking-property-mutator="setRequestProperty">
      <span slot="button">Submit Request</span>
    </booking-duplicate-form>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { helpers } from 'mixins/bookings'
import BookingDuplicateForm from 'components/booking/BookingDuplicateForm'

export default {
  props: ['id'],

  mixins: [helpers],

  components: {
    BookingDuplicateForm
  },

  computed: {
    ...mapState('booking/request', {
      booking: 'request'
    }),
    ...mapGetters('booking/request', ['haveBookingRequest'])
  },

  created () {
    this.getBookingRequestForDuplicate({ id: this.id })
      .catch((error) => {
        this.handleCaughtHttpExceptionForBooking(error, 'The booking request could not be found.')
      })
  },

  methods: {
    ...mapActions('booking/request', ['getBookingRequestForDuplicate', 'setBookingRequest', 'removeBookingRequestShortlistedTalent', 'setRequestProperty'])
  }
}
</script>
